import { render, staticRenderFns } from "./Paginador.vue?vue&type=template&id=04eb2b57&scoped=true&"
import script from "./Paginador.vue?vue&type=script&lang=js&"
export * from "./Paginador.vue?vue&type=script&lang=js&"
import style0 from "./Paginador.vue?vue&type=style&index=0&id=04eb2b57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eb2b57",
  null
  
)

export default component.exports